import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as PendingApprovalsActions from './pending-approvals.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';

@Injectable({
  providedIn: 'root'
})
export class PendingApprovalsStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  initStore() {
    this.store.dispatch(new PendingApprovalsActions.PendingApprovalsRefresh());
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.PENDING_CATALOGS, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Get:
          this.store.dispatch(new PendingApprovalsActions.PendingApprovalsRefresh());
      }
    });
  }
}
